module.exports = new __parcel__URL__("blueberries.688d225d.svg").toString();